import { ajax } from "../../../app/core/ajax";
import { buildMediaUrl } from "../../../app/core/util/util";
import { PopUp } from "../../components/components/popUp";
import { bind, observable } from "../../core/kendo";
import { bindLocalizedLanguage } from "../../core/ll";
import view from "./signaturePopup.view";

export class SignaturePopup extends PopUp {

    attachmentId: number;
    observable: any;
    openAttachmentInNewWindowLink: string;

    constructor() {
        super(view, { screenName: "signaturePopup" });

        this.popUpArgs = {
            width: 600
        };
    }

    bindEvents() {
        var me = this;

        me.get("#SignatureOkayButton").tie("click", function (e) {
            e.preventDefault();
            me.closePopUp();
        });

        me.observable = observable();
        bindLocalizedLanguage({ container: me.get("#SignaturePopup") });
        bind({ container: me.get("#SignaturePopup"), bind: ".bind-value", data: me.observable });
    }

    initialize(args) {
        var me = this,
            signatureId = args.Id;

        me.get("#SignatureThumbnailPreview").append("<div id='loading' style='height:50px' class='k-loading-image'></div>");
        me.loadSignature(signatureId);
    }

    loadSignature(signatureId) {
        var me = this;

        ajax({
            url: "Signature/" + signatureId,
            type: "GET"
        }).done(function (response) {
            var data = response.d.results;
            me.attachmentId = data.AttachmentId;

            me.observable.set("Email", data.Email);
            me.observable.set("FullName", data.FullName);
            me.loadAttachmentPreview();
        });
    }

    loadAttachmentPreview() {
        var me = this;

        $.when(me.activateAttachment()).done(function (response) {
            var source = me.getSourceUrl(response);
            me.createImagePreviewThumbnail(source);
        });
    }

    createImagePreviewThumbnail(source) {
        var me = this;

        var img = document.createElement("img");

        $(img).load(function () {
            me.get("#SignatureThumbnailPreview").find("#loading").remove();

            $.when(me.activateAttachment()).done(function (response) {
                me.openAttachmentInNewWindowLink = me.getSourceUrl(response);
            });

            me.get("#SignatureThumbnailPreview").on("click", ".link", function (e) {

                window.open(me.openAttachmentInNewWindowLink);
                me.get("#SignatureThumbnailPreview").find(".link").unbind("click");
                me.get("#SignatureThumbnailPreview").find(".link").disable();

                $.when(me.activateAttachment()).done(function (response) {
                    me.openAttachmentInNewWindowLink = me.getSourceUrl(response);
                }).then(function () {
                    me.get("#SignatureThumbnailPreview").find(".link").bind("click");
                    me.get("#SignatureThumbnailPreview").find(".link").enable();
                });

                e.preventDefault();
            });

            me.get("#SignatureThumbnailPreview").append('<a class="link img-thumbnail" target="_blank" id="SignatureThumbnailPreviewLink"></a>');
            $("#SignatureThumbnailPreviewLink").append(img);

        });

        img.src = source;
        img.style.maxHeight = "225px";
        img.style.maxWidth = "400px";
    }

    activateAttachment() {
        var me = this,
            deferred = $.Deferred();

        ajax({
            url: "Attachment/ActivateAttachment?id=" + me.attachmentId,
            type: "GET"
        }).done(function (response) {
            deferred.resolveWith(me, [response]);
        }).fail(function () {
            deferred.reject();
        });

        return deferred;
    }

    getSourceUrl(response) {
        return buildMediaUrl(response.d.results);
    }

}
